export { partnerPromotionalBannerHandler } from './partner-promotional-banner.handler';
